import {
	isDateLessThanXYearsInPastExactlyFromChosenDay,
	isDateWithOrder,
	isFullySpecifiedDate,
} from 'app/forms/validations/common';
import isBirthNumber from 'app/forms/validations/isBirthNumber';
import isBusinessIn from 'app/forms/validations/isBusinessIn';
import isBusinessName from 'app/forms/validations/isBusinessName';
import isFirstName from 'app/forms/validations/isFirstName';
import isMunicipality from 'app/forms/validations/isMunicipality';
import isSurname from 'app/forms/validations/isSurname';
import isZipCode from 'app/forms/validations/isZipCode';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const ROBO_ADVISORY_FORM_NAME = 'roboAdvisory-filter';

const { firstName, surname, businessName, personIn, businessIn, zipCode, municipality, product } =
	COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	surname,
	firstName,
	businessName,
	personIn,
	businessIn,
	zipCode,
	municipality,
	product,
	types: 'types',
	states: 'states',
	createdDateFrom: 'createdDateFrom',
	createdDateTo: 'createdDateTo',
};

export default () => ({
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [isSurname()],
	},
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [isFirstName()],
	},
	[FIELDS.businessName]: {
		deepPath: [FIELDS.businessName],
		validations: [isBusinessName()],
	},
	[FIELDS.personIn]: {
		deepPath: [FIELDS.personIn],
		validations: [isBirthNumber()],
	},
	[FIELDS.businessIn]: {
		deepPath: [FIELDS.businessIn],
		validations: [isBusinessIn()],
	},
	[FIELDS.zipCode]: {
		deepPath: [FIELDS.zipCode],
		validations: [isZipCode()],
	},
	[FIELDS.municipality]: {
		deepPath: [FIELDS.municipality],
		validations: [isMunicipality()],
	},
	[FIELDS.product]: {
		deepPath: [FIELDS.product],
		validations: [],
	},
	[FIELDS.types]: {
		deepPath: [FIELDS.types],
		validations: [],
	},
	[FIELDS.states]: {
		deepPath: [FIELDS.states],
		validations: [],
	},
	[FIELDS.createdDateFrom]: {
		deepPath: [FIELDS.createdDateFrom],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.createdDateFrom, toFieldName: FIELDS.createdDateTo }),
			isDateLessThanXYearsInPastExactlyFromChosenDay({ yearsToSubtract: 2 }),
		],
	},
	[FIELDS.createdDateTo]: {
		deepPath: [FIELDS.createdDateTo],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.createdDateFrom, toFieldName: FIELDS.createdDateTo }),
			isDateLessThanXYearsInPastExactlyFromChosenDay({ yearsToSubtract: 2 }),
		],
	},
});
